import React from 'react'

import Link from 'next/link'
// import { FormattedMessage } from 'react-intl'
import styles from './media.module.scss'
import Avatar from '@components/app/avatar'
// import Button from '@components/common/button'


interface Props {
  name: string
  username: string
  imageUrl: string
  shortBio: string
}

const Userinfo = ({ name, username, imageUrl, shortBio }: Props) => (
  <div className="d-flex">
    <div className="flex0 mr-3">
      <Link
        href={`/user/${username}`}
        className={`d-block tx-w400 tx-g900 ${styles.userAvatar}`}
      >
        <Avatar src={imageUrl} width="100" alt={name} />
      </Link>
    </div>
    <div className="flex1">
      <Link
        href={`/user/${username}`}
        className="alt tx-16 tx-w600 tx-g900"
      >
        {name}
      </Link>
      <p className="tx-12 tx-g800">
        <Link
          href={`/user/${username}`}
          className="nohover tx-g800"
        >
          {shortBio.substr(0, 50)}
          {shortBio.length > 50 && '...'}
        </Link>
      </p>
      {/* <Button className="sm"><FormattedMessage id="app.follow" defaultMessage="Follow" /></Button> */}
    </div>
  </div>
)

export default Userinfo
